import { ACTIONS_NOTIFICATION } from '../actions/notification';

export default (state = {}, action) => {
    switch (action.type) {
        case ACTIONS_NOTIFICATION.GET_NOTIFICATION_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data
            };
        case ACTIONS_NOTIFICATION.GET_NOTICE_LATEST_SUCCESS:
            return {
                ...state,
                statusNotice: action.type,
                responseNotice: action.data
            };
        default:
            return state;
    }
};
